import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import ClearIcon from "@mui/icons-material/Clear";
import IconButton from "@mui/material/IconButton";
import { SearchInputField } from "../../form/search-input-field/SearchInputField.js";
function UserSearchBar(props) {
  const { query, onQueryChange, onClearQuery } = props;
  const { t } = useTranslation("ui");
  return /* @__PURE__ */ jsx(
    SearchInputField,
    {
      value: query,
      onChange: onQueryChange,
      placeholder: t("이름/소속명/담당업무/이메일/휴대폰번호 검색"),
      endIcon: query ? /* @__PURE__ */ jsx(IconButton, { size: "small", "aria-label": "clear", onClick: onClearQuery, children: /* @__PURE__ */ jsx(ClearIcon, { fontSize: "small" }) }) : void 0
    }
  );
}
export {
  UserSearchBar
};
